export default __webpack_public_path__ + "static/media/leaderboardOne.7f1ea5b3.jpeg";